import CrudCustom from '../../../libs/custom/CrudCustom';

let TipePengurangPajakService = new CrudCustom('/tipe-pengurang-pajaks');
export default TipePengurangPajakService;
